import React from 'react';
import { useDispatch } from "react-redux";
import { setNewFirst_Name, setNewLast_Name, setNewEmail, setFirst_Name, setLast_Name } from "../../../../Features/Auth/authSlice";
import {patchCurrentUser} from "../../../../Features/Auth/authSlice";
import { v4 as uuidv4 } from 'uuid';

const ButtonRow = ({ newUserData }) => {
    const dispatch = useDispatch();

    const handleCancel = () => {
        try {
            dispatch(setNewFirst_Name(""));
            dispatch(setNewLast_Name(""));
            dispatch(setNewEmail(""));
        } catch (error) {
            console.error("Error in handleCancel:", error);
        }
    };

    const handleSave = async () => {
        try {

            dispatch(setFirst_Name(newUserData.first_name));
            dispatch(setLast_Name(newUserData.last_name));
            await dispatch(patchCurrentUser(newUserData));
            dispatch(setNewFirst_Name(""));
            dispatch(setNewLast_Name(""));
            dispatch(setNewEmail(""));
        } catch (error) {
            console.error("Error in handleSave:", error);
        }
    };

    return (
        <div className="buttonRow flex flex-row justify-center sm:justify-end gap-4">
            <div
                key={uuidv4()}
                onClick={(() => handleCancel())}
                className={((Object.keys(newUserData).length > 0) ? " opacity-100 " : " opacity-40 ") + `border-3 w-1/2 sm:w-1/4 text-center border-gold-accent text-white h-14 p-2.5 rounded-lg cursor-pointer `}>
                <div>Cancel</div>
            </div>

            <div
                onClick={() => { handleSave() }}
                className="bg-gold-accent w-1/2 sm:w-1/4 text-center hover:bg-gold-accent-hover text-white h-14 rounded-lg p-3 cursor-pointer ">
                <div className={`sm:hidden`}>Save Changes</div>
                <div className={`hidden sm:block`}>Save</div>
            </div>
        </div>
    );
};

export default ButtonRow;